import { createContext, useContext } from "react";

const BabyStationContext = createContext();

export const useBabyStation = () => useContext(BabyStationContext);

export default BabyStationContext;

export function withBabyStation(Component) {
  return (props) => {
    return (
      <BabyStationContext.Consumer>
        {(babyStation) => <Component babyStation={babyStation} {...props} />}
      </BabyStationContext.Consumer>
    );
  };
}
